<absensi-table>

    <div if={state.showToast} class="toast toast-{state.toastSuccess ? 'success' : 'error'} toast-fixed">
        <button class="btn btn-clear float-right" onclick={closeToast}></button>
        {state.toastMessage}
    </div>

    <div class="modal {state.showModalDeactivateReason ? 'active' : ''}" id="modal-deactivate-reason">
        <div class="modal-container">
            <div class="modal-header">
                <div class="modal-title h5">Konfirmasi Hapus</div>
            </div>
            <div class="modal-body">
                <div class="content">
                    <div class="container">
                        <template if={state.showToastDeactivate}>
                            <div class="toast toast-{state.deactivateSuccess ? 'success' : 'error'}">
                                <button class="btn btn-clear float-right" onclick={closeToastDeactivate}></button>
                                {state.toastDeactiveMessage}
                            </div>
                        </template>
                    </div>
                    <!-- content here -->
                    <!-- form input control -->
                    <div class="form-group">
                        <input class="form-input" type="text" id="deactivate-reason-studentClassID" disabled
                               value={state.deactivatedStudentClassID}>
                    </div>
                    <div class="form-group">
                        <input class="form-input" type="text" id="deactivate-reason-input" placeholder="Alasan">
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn" onclick={closeModalDeactivateReason}>Batal</button>
                <button class="btn btn-success {state.deactivateOnProgress ? 'loading' : ''}" onclick={deactivate}>
                    Simpan
                </button>
            </div>
        </div>
    </div>

    <div class="modal {state.transferDialog.open ? 'active' : ''}"
         role="dialog"
         aria-modal="true"
         aria-hidden={!state.transferDialog.open}
         aria-labelledby="absensi-transfer-dialog-title">
        <a class="modal-overlay" href="#close" role="button" aria-label="Tutup dialog" onclick={closeTransferDialog}></a>
        <div class="modal-container">
            <div class="modal-header">
                <button class="btn btn-clear float-right" aria-label="Tutup" disabled={state.transferDialog.saving} onclick={closeTransferDialog}></button>
                <div class="modal-title h5" id="absensi-transfer-dialog-title">Pindahkan Siswa</div>
            </div>
            <div class="modal-body">
                <div class="content">
                    <p>Pindahkan {state.selectedStudentClassIDs.length} siswa ke tahun ajaran dan kelas tujuan?</p>
                    <div class="form-group">
                        <label class="form-label">Dari</label>
                        <input class="form-input" disabled value="{sourceYearLabel()} → {props.classLabel}">
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="absensi-dest-year">Ke tahun akademik</label>
                        <select id="absensi-dest-year" class="form-select" value={state.transferDialog.destYear} onchange={event => update({transferDialog: {...state.transferDialog, destYear: event.target.value}})}>
                            <option value="">Pilih tahun akademik</option>
                            <option each={year in (props.academicYears || [])} value={year.ID}>{year.label}</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label class="form-label" for="absensi-dest-class">Ke kelas</label>
                        <select id="absensi-dest-class" class="form-select" value={state.transferDialog.destClass} onchange={event => update({transferDialog: {...state.transferDialog, destClass: event.target.value}})}>
                            <option value="">Pilih kelas</option>
                            <option each={item in (props.classItems || [])} value={item.label}>{item.label}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn" disabled={state.transferDialog.saving} onclick={closeTransferDialog}>Batal</button>
                <button id="absensi-transfer-confirm"
                        class="btn btn-primary loading-{state.transferDialog.saving}"
                        disabled={state.transferDialog.saving || !state.transferDialog.destYear || !state.transferDialog.destClass}
                        onclick={confirmTransfer}>Pindahkan</button>
            </div>
        </div>
    </div>

    <div class="container">
        <template if={props.students && props.students.length == 0}>
            <div class="empty">
                <div class="empty-icon">
                    <i class="icon icon-people icon-4x"></i>
                </div>
                <p class="empty-title h5">Belum ada siswa di absen</p>
                <p class="empty-subtitle">Klik tombol `tambah siswa` untuk menambahkan siswa baru</p>
                <div class="empty-action">
                    <button class="btn btn-primary" onclick={redirectToInputForm}>Tambah siswa</button>
                    <button class="btn btn-success" onclick={redirectToTransferForm} style="margin-left: 2%;">Import</button>
                </div>
            </div>
        </template>
        <template if={props.students && props.students.length > 0}>
            <table class="table" tabindex="0" aria-label="Daftar absensi siswa">
                <thead>
                <tr>
                    <th class="checkbox-col"><input type="checkbox" aria-label="Pilih semua" checked={allSelected()} onchange={toggleSelectAll}></th>
                    <th>Nama</th>
                    <th>Alias</th>
                    <th>Kehadiran</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr each={item in props.students}
                    style="{hideOnTable(item.studentClassID, state.hideStudentClassIDs) ? 'display: none;' : ''}">
                    <td class="checkbox-col"><input type="checkbox" aria-label="Pilih {item.name}" checked={state.selectedStudentClassIDs.indexOf(item.studentClassID) >= 0} onchange={() => toggleSelect(item)}></td>
                    <td>
                        {item.name}
                    </td>
                    <td>
                        {item.alternativeID}
                    </td>
                    <td>
                        <div class="form-group">
                            <select class="form-select {state.isAttendanceTypeLoading ? 'loadng' : ''}"
                                    id={item.studentClassID} onchange={onChangeAttendance}>
                                <option value="nan">Choose an option</option>
                                <option each={attendanceItem in state.attendanceTypes} value={attendanceItem.ID}
                                        selected={item.attendanceTypeID == attendanceItem.ID ? 'selected' : ''}>
                                    {attendanceItem.label}
                                </option>
                            </select>
                        </div>
                    </td>
                    <td>
                        <div class="form-group">
                            <button class="btn btn-error" data-deactiveStudentClassID={item.studentClassID}
                                    onclick={showModalDeactivateReason}>Hapus
                            </button>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>

                    </td>
                    <td>
                        <button class="btn btn-primary" onclick={redirectToInputForm}>Tambah siswa</button>
                    </td>
                    <td>

                    </td>
                    <td>

                    </td>
                </tr>
                </tbody>
            </table>


        </template>
        <div class="container"
             style="display: {props.students && props.students.length > 0 ? 'block' : 'none'}; margin-top: 3%;">
            <div class="columns">
                <div class="col-4">
                    <button class="btn btn-success {state.saveOnProgress ? 'loading' : ''}" onclick={submitAttendance}>
                        Submit Absensi
                    </button>
                    <button if={state.selectedStudentClassIDs.length > 0} class="btn btn-primary" onclick={openTransferDialog} style="margin-left: 2%;">
                        Pindahkan ({state.selectedStudentClassIDs.length})
                    </button>
                </div>
            </div>
        </div>

        <style>
            absensi-table .checkbox-col { width: 2.5rem; text-align: center; }
            absensi-table .toast-fixed { position: fixed; top: 1rem; right: 1rem; z-index: 200; min-width: 20rem; max-width: 28rem; }
        </style>

        <script>
            import {route, router, setBase} from '@riotjs/route'

            export default {
                state: {
                    saveOnProgress: false,
                    toastMessage: '',
                    toastSuccess: true,
                    showToast: false,
                    attendanceTypes: [],
                    isAttendanceTypeLoading: false,
                    showModalDeactivateReason: false,
                    deactivatedStudentClassID: '',
                    toastDeactiveMessage: '',
                    showToastDeactivate: false,
                    deactivateSuccess: true,
                    deactivateOnProgress: false,
                    hideStudentClassIDs: [],
                    selectedStudentClassIDs: [],
                    transferDialog: {open: false, saving: false, destYear: '', destClass: ''},
                },
                onMounted(props, state) {
                    this.loadAttendanceTypes()
                    this.transferKeydownHandler = event => {
                        if (event.key === 'Escape' && this.state.transferDialog.open) {
                            this.closeTransferDialog(event)
                        }
                    }
                    window.addEventListener('keydown', this.transferKeydownHandler)
                },
                onBeforeUnmount() {
                    window.removeEventListener('keydown', this.transferKeydownHandler)
                },
                hideOnTable(id, data) {
                    for (let i = 0; i < data.length; i++) {
                        if (data[i] == id) {
                            return true;
                        }
                    }
                    return false;
                },
                visibleStudents() {
                    if (!this.props.students) return []
                    return this.props.students.filter(item => !this.hideOnTable(item.studentClassID, this.state.hideStudentClassIDs))
                },
                allSelected() {
                    const visible = this.visibleStudents()
                    return visible.length > 0 && visible.every(item => this.state.selectedStudentClassIDs.indexOf(item.studentClassID) >= 0)
                },
                toggleSelect(item) {
                    const ids = this.state.selectedStudentClassIDs.slice()
                    const idx = ids.indexOf(item.studentClassID)
                    if (idx >= 0) ids.splice(idx, 1)
                    else ids.push(item.studentClassID)
                    this.update({selectedStudentClassIDs: ids})
                },
                toggleSelectAll() {
                    const visible = this.visibleStudents()
                    if (this.allSelected()) {
                        const removeIDs = visible.map(item => item.studentClassID)
                        this.update({selectedStudentClassIDs: this.state.selectedStudentClassIDs.filter(id => removeIDs.indexOf(id) < 0)})
                    } else {
                        const addIDs = visible.map(item => item.studentClassID)
                        const merged = this.state.selectedStudentClassIDs.slice()
                        for (const id of addIDs) { if (merged.indexOf(id) < 0) merged.push(id) }
                        this.update({selectedStudentClassIDs: merged})
                    }
                },
                sourceYearLabel() {
                    const years = this.props.academicYears || []
                    const year = years.find(y => y.ID === this.props.academicYearID)
                    return year ? year.label : ''
                },
                openTransferDialog(event) {
                    this.transferTrigger = event && event.currentTarget
                    this.update({
                        transferDialog: {open: true, saving: false, destYear: '', destClass: ''},
                        toastMessage: '',
                    })
                    window.requestAnimationFrame(() => {
                        const confirm = document.getElementById('absensi-transfer-confirm')
                        if (confirm) confirm.focus()
                    })
                },
                closeTransferDialog(event) {
                    if (event) event.preventDefault()
                    if (this.state.transferDialog.saving) return
                    this.update({transferDialog: {open: false, saving: false, destYear: '', destClass: ''}})
                    if (this.transferTrigger) {
                        this.transferTrigger.focus()
                        this.transferTrigger = null
                    }
                },
                confirmTransfer(event) {
                    event.preventDefault()
                    const d = this.state.transferDialog
                    if (d.saving || !d.destYear || !d.destClass) return
                    this.update({transferDialog: {...d, saving: true}, toastMessage: ''})
                    axios.post('/api/v1/student/transfer', {
                        studentClassIDs: this.state.selectedStudentClassIDs,
                        destinationAcademicYearId: d.destYear,
                        destinationClassLabel: d.destClass,
                    }).then(response => {
                        const count = response.data && response.data.transferred || this.state.selectedStudentClassIDs.length
                        this.update({
                            transferDialog: {open: false, saving: false, destYear: '', destClass: ''},
                            selectedStudentClassIDs: [],
                            showToast: true,
                            toastSuccess: true,
                            toastMessage: `${count} siswa berhasil dipindahkan`,
                        })
                    }).catch(error => {
                        const message = error.response && error.response.data && error.response.data.message
                        this.update({
                            transferDialog: {...d, saving: false},
                            showToast: true,
                            toastSuccess: false,
                            toastMessage: message || 'Siswa tidak berhasil dipindahkan',
                        })
                    })
                },
                submitAttendance(e) {
                    e.preventDefault();
                    if (!this.props.students) {
                        return
                    }
                    const attendanceDate = this.props.attendanceDate;
                    let payloadItems = [];
                    let selectedAttendanceInvalids = []
                    let validationFailed = false;
                    this.props.students.forEach(function (student) {
                        const attend = document.getElementById(student.studentClassID).checked
                        let attendanceTypeSelector = document.getElementById(student.studentClassID);
                        let payloadItem = {
                            studentClassID: student.studentClassID,
                            attend: false, // deprecated
                            attendanceTypeID: attendanceTypeSelector[attendanceTypeSelector.selectedIndex].value,
                            attendanceDate: attendanceDate,
                        };
                        if (payloadItem.attendanceTypeID == "nan") {
                            if (!attendanceTypeSelector.classList.contains('is-error')) {
                                attendanceTypeSelector.classList.add("is-error");
                                attendanceTypeSelector.insertAdjacentHTML("afterend", '<p class="form-input-hint">Jenis kehadiran siswa harus dipilih</p>')
                            }
                            validationFailed = true;
                        }
                        payloadItems.push(payloadItem);
                    })
                    if (validationFailed) {
                        return;
                    }
                    const payload = {
                        items: payloadItems,
                    }
                    this.update({
                        saveOnProgress: true,
                    })
                    axios({
                        method: 'POST',
                        url: '/api/v1/student/attendance/submit',
                        data: payload,
                    }).then((resp) => {
                        console.log(resp)
                        this.update({
                            showToast: true,
                            toastMessage: 'Data berhasil disimpan',
                            toastSuccess: true,
                        })
                    }).catch(e => {
                        console.log(e)
                        this.update({
                            showToast: true,
                            toastMessage: 'Data tidak berhasil disimpan',
                            toastSuccess: false,
                        })
                    }).finally(() => {
                        this.update({
                            saveOnProgress: false,
                        })
                        var p = this;
                        setTimeout(() => {
                            p.update({
                                showToast: false,
                            })
                        }, "2000")
                    });
                },
                closeToast() {
                    this.update({
                        showToast: false,
                    })
                },
                redirectToInputForm(e) {
                    e.preventDefault()
                    router.push('/#absensi/input/form');
                },
                redirectToTransferForm(e) {
                    e.preventDefault()
                    router.push('/#absensi/input/form/transfer');
                },
                loadAttendanceTypes() {
                    this.update({
                        isAttendanceTypeLoading: true,
                    })
                    axios.get(`/api/v1/attendance/types`)
                        .then(res => {
                            this.update({
                                attendanceTypes: res.data.items,
                            })
                        }).catch(e => {
                        console.log(e)
                    }).finally(() => {
                        this.update({
                            isAttendanceTypeLoading: false,
                        })
                    })
                },
                showModalDeactivateReason(e) {
                    const studentClassID = e.target.dataset.deactivestudentclassid;
                    this.update({
                        showModalDeactivateReason: true,
                        deactivatedStudentClassID: studentClassID,
                    })
                },
                closeModalDeactivateReason(e) {
                    e.preventDefault();
                    document.getElementById('deactivate-reason-input').value = '';
                    this.update({
                        showModalDeactivateReason: false,
                        deactivatedStudentClassID: "",
                    })
                },
                closeToastDeactivate() {
                    this.update({
                        showToastDeactivate: false,
                    })
                },
                deactivate(e) {
                    e.preventDefault()
                    const studentClassID = document.getElementById('deactivate-reason-studentClassID').value;
                    const reasonValue = document.getElementById('deactivate-reason-input').value;
                    const payload = {
                        reason: reasonValue,
                    }
                    this.update({
                        deactivateOnProgress: true,
                    })
                    document.getElementById('deactivate-reason-input').value = "";
                    axios({
                        method: 'PATCH',
                        url: '/api/v1/student/class/' + studentClassID + "/deactivate",
                        data: payload,
                    }).then((resp) => {
                        console.log(resp)
                        this.update({
                            toastDeactiveMessage: 'Siswa berhasil dihapus',
                            showModalDeactivateReason: false,
                            hideStudentClassIDs: [
                                ...this.state.hideStudentClassIDs,
                                studentClassID,
                            ],
                        })
                    }).catch(e => {
                        this.update({
                            toastDeactiveMessage: 'Siswa tidak berhasil dihapus',
                            deactivateSuccess: false,
                            showToastDeactivate: true,
                        })
                        console.log(e)
                    }).finally(() => {
                        this.update({
                            deactivateOnProgress: false,
                            deactivatedStudentClassID: '',
                        })
                    });
                },
                onChangeAttendance(e) {
                    let attendanceTypeSelector = document.getElementById(e.target.id);
                    let r = attendanceTypeSelector.parentNode;
                    let nextSibling = attendanceTypeSelector.nextSibling;
                    if (r && nextSibling) {
                        if (nextSibling.classList.contains("form-input-hint")) {
                            r.removeChild(nextSibling);
                            attendanceTypeSelector.classList.remove("is-error");
                        }
                    }
                }
            }
        </script>
</absensi-table>
